<template>
  <div id="app" v-bind:class="'app-' + route">
    <top-bar></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TopBar from '@/components/TopBar/TopBar'

export default {
  name: 'app',
  components: {
    TopBar
  },
  computed: {
    ...mapState({
      route: state => state.route.name
    })
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  line-height: 1.25rem;
}
body, html {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #212121;
}
#app.app-home {
  position: fixed;
  z-index: 1000;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  background: url('./assets/map-bg.jpg') repeat;
  background-size: auto auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue